import { Hub } from 'aws-amplify/utils';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { toast } from 'sonner';

import { NonAuthenticatedRoute } from '@/app/constant';
import { Button } from '@/components/ui/button';
import { startSsoSignIn } from '@/utils/sso.util';
import { generatePathWithSearch } from '@/utils/url.util';

export const SSO = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const unsubscribe = Hub.listen('auth', ({ payload }) => {
      if (payload.event === 'signInWithRedirect_failure') {
        toast.error('An error has occurred during the OAuth flow.');
      }
    });

    return unsubscribe;
  }, []);

  return (
    <>
      <div className="relative w-full text-center">
        <hr className="border-chariot-stroke absolute top-2.5 w-full border-t-2" />
        <span className="bg-chariot-background-primary relative px-8 text-center font-semibold">
          OR
        </span>
      </div>
      <Button
        className="w-full"
        variant="secondary"
        onClick={() => {
          startSsoSignIn('Google', searchParams.get('redirect'));
        }}
      >
        <img
          src="/icons/GoogleSSO.svg"
          alt="Google SSO"
          className="mr-2 size-5"
        />
        <span>Sign in with Google</span>
      </Button>
      <Button
        className="w-full"
        variant="secondary"
        onClick={() =>
          navigate(
            generatePathWithSearch({
              pathname: NonAuthenticatedRoute.LOGIN_SSO,
            })
          )
        }
      >
        Sign in with SSO
      </Button>
    </>
  );
};
